export default __webpack_public_path__ + "05ec297.png";